module.exports = __webpack_public_path__ + "img/home_55.8cc943ff.png";